import Env from "../Env";
import Request from "./Request";

export default class PrivacyPolicyRequest extends Request {

  static loadPrivacySettings(handlerSuccess, handlerError, handlerComplete) {
    const url = Env.getBackendURL() + 'config/privacy/load';
    Request.load(url, handlerSuccess, handlerError, handlerComplete);
  }

  static savePrivacySettings(data) {
    return Request.submitR(Request.API_PRIVACY_SAVE, data);
  }

  static uploadCookieIcon(name, file, headers) {
    return Request.submitFiles(Request.API_UPLOAD_COOKIE_ICON, { name: file }, headers);
  }
}
